import { render } from "./bankAccountData.vue?vue&type=template&id=0ee3a9ca&ts=true"
import script from "./bankAccountData.vue?vue&type=script&lang=ts"
export * from "./bankAccountData.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__